import { Star } from "lucide-react";

export const LovedBadge = ({ product, className = "" }) => {
  if (!(Number(product?.beauty) >= 9)) return null;
  return (
    <span data-testid={`loved-badge-${product.id}`}
      className={`inline-flex items-center gap-1 rounded-full bg-[#2D2825]/85 backdrop-blur text-white text-[10px] sm:text-[11px] px-2 py-0.5 sm:px-2.5 sm:py-1 ${className}`}>
      <Star size={11} className="fill-[#F2C4BD] stroke-[#F2C4BD]" /> Più amato
    </span>
  );
};

export const BestSellerBadge = ({ product, className = "" }) => {
  if (!product?.best_seller) return null;
  return (
    <span data-testid={`bestseller-badge-${product.id}`}
      className={`inline-flex items-center gap-1 rounded-full bg-[#E9C46A] text-[#2D2825] font-medium text-[10px] sm:text-[11px] px-2 py-0.5 sm:px-2.5 sm:py-1 ${className}`}>
      <Star size={11} className="fill-[#2D2825] stroke-[#2D2825]" /> Best seller
    </span>
  );
};

export const ProductBadges = ({ product, className = "" }) => (
  <div className={`flex flex-col items-end gap-1 ${className}`}>
    <BestSellerBadge product={product} />
    <LovedBadge product={product} />
  </div>
);
